import { PartnerWorkflowStatus } from 'clickNgo/entities/partner/configs'

import { IPartnerEditorData, IPartnerEditorSettings } from './models'

export enum PartnerEditorFormKeys {
  AdditionalInfo = 'partner-editor-additional-info',
  Attachments = 'partner-editor-attachments',
  BasicInfo = 'partner-editor-basic-info',
  LegalInfo = 'partner-editor-legal-info',
  Setting = 'partner-editor-settings',
  Program = 'partner-editor-program-code',
  Accreditation = 'partner-editor-accreditation',
  MandatoryAttachments = 'partner-editor-mandatory-attachments',
}
export enum UpdatePartnerResult {
  Updated = 'updated',
  Requested = 'requested',
  Failed = 'failed',
}

export enum PartnerEditorFormSettings {
  ActualData = 'actualData',
  DoCopyBasicName = 'doCopyBasicName',
  DoCopyBasicAddress = 'doCopyBasicAddress',
  CurrentMenuItem = 'currentMenuItem',
  EditableMenuItems = 'editableMenuItems',
  IsInactive = 'isInactive',
  IsReadOnly = 'isReadOnly',
  IsLoading = 'isLoading',
}

export const partnerEditorDefaultSetting: IPartnerEditorSettings = {
  actualData: {} as IPartnerEditorData,
  doCopyBasicName: false,
  doCopyBasicAddress: false,
  currentMenuItem: 0,
  editableMenuItems: [],
  isInactive: false,
  isReadOnly: false,
  isLoading: false,
}

export const PARTNER_EDITOR_FORM_KEYS = {
  basic: PartnerEditorFormKeys.BasicInfo,
  legal: PartnerEditorFormKeys.LegalInfo,
  additional: PartnerEditorFormKeys.AdditionalInfo,
  attachments: PartnerEditorFormKeys.Attachments,
  settings: PartnerEditorFormKeys.Setting,
}

export const READ_ONLY_BASIC_INFO_FIELDS = ['hierarchyType', 'topPartnerId']

export const READ_ONLY_WORKFLOW_STATUS = [
  PartnerWorkflowStatus.APPROVED,
  PartnerWorkflowStatus.WIP,
  PartnerWorkflowStatus.DRAFT,
]

export const PARTNER_CONTAINER_HEADER_HEIGHT = 80
